import { compose, withHandlers } from 'recompose'
import StepperHeader from './StepperHeader'

const withNextStepHandler = withHandlers({
  nextStepHandler: ({
    setCurrentStepIndex,
    dateTimeStepIndex,
    currentStepIndex,
    beforeNavigatingToDateTimeStep
  }) => (index) => {
    currentStepIndex !== index && dateTimeStepIndex === index
      && beforeNavigatingToDateTimeStep()
    setCurrentStepIndex(index)
  }
})

export default compose(
  withNextStepHandler
)(StepperHeader)
